export default [
  {
    title: 'Nadštandardné\n príjmy',
    text: 'Až 100 našich partnerov zarába viac než 1768€ mesačne.',
    icon: 'money',
  },
  {
    title: 'Transparentný\n systém odmeňovania',
    text: 'Férový a štedrý systém odmeňovania s pasívnym príjmom.',
    icon: 'hands',
  },
  {
    title: 'Smart\n portál',
    text: 'Naši obchodní poradcovia využívajú efektívny moderný portál.',
    icon: 'windows',
  },
  {
    title: 'Databáza\n kontaktov',
    text: 'Prístup do online aplikácie s reálnymi obchodnými príležitosťami na pár klikov.',
    icon: 'network',
  },
  {
    title: 'Digitálne\n DNA',
    text: 'Využívame tie najmodernejšie digitálne nástroje.',
    icon: 'dna',
  },
  {
    title: 'Flexibilný\n pracovný čas',
    text: 'Úplná sloboda v mieste, čase a rytme práce.',
    icon: 'clock',
  },
  {
    title: 'Bonusový\n systém',
    text: 'Jednoduchá výmena získaných bodov za darčeky, pomôcky alebo reklamu.',
    icon: 'bonus',
  },
  {
    title: 'Bezplatné\n vzdelávanie',
    text: 'Množstvo príležitostí zlepšiť si schopnosti aj efektivitu.',
    icon: 'learning',
  },

  {
    title: 'Podnikanie popri zamestnaní',
    text: 'Naši partneri popri tejto práci bežne zvládajú aj ďalšie zamestnanie.',
    icon: 'business',
  },
  {
    title: 'Férový\n kariérny rast',
    text: 'Transparentné vyhodnotenia výsledkov a kariérny postup na základe transparentných výsledkov.',
    icon: 'growth',
  },
  {
    title: 'Podnikanie\n bez kapitálu',
    text: 'Jedinečný spôsob na naštartovanie nových príležitostí.',
    icon: 'coins',
  },
];
